import type { PeerMessage } from "@duelgame/shared";

/** Minimal peer channel used by DuelController (WebRTC session or loopback). */
export interface PeerLink {
  sendPeer(msg: PeerMessage): void;
  onPeerMessage(handler: (msg: PeerMessage) => void): () => void;
}

type Endpoint = PeerLink & { receive: (msg: PeerMessage) => void };

function makeEndpoint(deliver: (msg: PeerMessage) => void): Endpoint {
  const handlers = new Set<(msg: PeerMessage) => void>();
  return {
    sendPeer(msg) {
      // Async so a send never re-enters the sender synchronously.
      queueMicrotask(() => deliver(msg));
    },
    onPeerMessage(handler) {
      handlers.add(handler);
      return () => handlers.delete(handler);
    },
    receive(msg) {
      for (const h of handlers) h(msg);
    },
  };
}

/** In-memory A↔B pair for offline tutorial / bots. */
export function createLoopbackPair(): [PeerLink, PeerLink] {
  let a!: Endpoint;
  let b!: Endpoint;
  a = makeEndpoint((msg) => b.receive(msg));
  b = makeEndpoint((msg) => a.receive(msg));
  return [a, b];
}
